import { Dispatch } from 'react'
import GTModal from '../../mantine/GTModal'
import { AddListsModalContent } from './AddListsModal'

interface OverviewListsModalProps {
    isOpen: boolean
    setisOpen: Dispatch<React.SetStateAction<boolean>>
}
// Customize Daily Overview: which cards are shown. Order is set on the cards themselves.
const EditModal = ({ isOpen, setisOpen }: OverviewListsModalProps) => {
    return (
        <>
            <GTModal
                open={isOpen}
                setIsModalOpen={setisOpen}
                size="lg"
                tabs={{ title: 'Customize Daily Overview', body: <AddListsModalContent /> }}
            />
        </>
    )
}

export default EditModal
